import {Totals} from '../../../../../common/components/Totals/Totals';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {Text} from 'wix-ui-tpa/cssVars';
import {isFreeShippingCoupon} from '../../../../../domain/utils/total.util';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const DeliveryTotalsRow = () => {
  const localeKeys = useLocaleKeys();
  const {cartSummary, cart, isCartSummaryUpdating} = useControllerProps().checkoutStore;

  if (!cart.hasShippableItems) {
    return;
  }

  const getShippingRowTitleText = (): string => {
    return cart.deliveryInfo.method?.pickup
      ? localeKeys.checkout.orderSummary.totals.pickup.label()
      : localeKeys.checkout.order_summary.totals.delivery();
  };

  const getShippingRowValueText = (): string => {
    if (!cart.deliveryInfo.method) {
      return localeKeys.checkout.summary.shipping.noAmount();
    }

    if (
      cartSummary!.priceSummary.delivery.amount === 0 ||
      (cartSummary!.couponDiscount && isFreeShippingCoupon(cartSummary!.couponDiscount))
    ) {
      return localeKeys.checkout.order_summary.totals.free();
    }
    return cartSummary!.priceSummary.delivery.formattedAmount;
  };

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.ShippingRow}
      title={getShippingRowTitleText()}
      value={() =>
        isCartSummaryUpdating ? (
          <TotalUpdateSkeleton />
        ) : (
          <Text
            data-hook={TotalsSectionDataHooks.ShippingRowValue}
            aria-label={!cart.deliveryInfo.method ? localeKeys.checkout.orderTotal.noShipping.ariaLabel() : undefined}>
            {getShippingRowValueText()}
          </Text>
        )
      }
    />
  );
};
